import styles from "./rrmLink.module.css";
import { TRRMDisplayEntry } from "../../services/types/user.types";
import React, { useState } from "react";
import Modal from "../modals/modal/Modal";
import RrmModelPopup from "../modals/rrmModel/rrmModelPopup";
import { tWithKeyAttr as t } from "../../i18nHelper";

function RrmLink({
  score,
  RRMScore,
  scoreList,
  additionalStyles,
  showScoreInButton = false,
  enablePopup = true,
  embedded = false,
  label,
  popupTitle,
}: {
  score: number;
  RRMScore: number;
  scoreList: TRRMDisplayEntry[];
  additionalStyles?: React.CSSProperties;
  showScoreInButton?: boolean;
  enablePopup?: boolean;
  embedded?: boolean;
  label?: string;
  popupTitle?: string;
}) {
  const color =
    scoreList.find((item) => item.rrmseq === RRMScore)?.color ?? "gray";
  const [openModal, setOpenModal] = useState<boolean>(false);
  const showPopup = enablePopup && scoreList[0]?.statusId === 1;

  const buttonText = showScoreInButton
    ? `${t("SCORE")}: ${score} · RRM (${RRMScore})`
    : `RRM (${RRMScore})`;

  return (
    <div
      className={`${styles.link} ${embedded ? styles.link_embedded : ""}`}
      style={additionalStyles}
    >
      {label && <p className={styles.link__label}>{label}</p>}
      <button className={styles.link__link} style={{ backgroundColor: color }}>
        {buttonText}
        {RRMScore >= 5 && (
          <svg
            width="20"
            height="20"
            viewBox="-1.7 0 20.4 20.4"
            xmlns="http://www.w3.org/2000/svg"
            className="cf-icon-svg"
            fill="#fff"
          >
            <path d="M16.406 10.283a7.917 7.917 0 1 1-7.917-7.917 7.916 7.916 0 0 1 7.917 7.917zM9.48 14.367a1.003 1.003 0 1 0-1.004 1.003 1.003 1.003 0 0 0 1.004-1.003zM7.697 11.53a.792.792 0 0 0 1.583 0V5.262a.792.792 0 0 0-1.583 0z" />
          </svg>
        )}
      </button>
      {showPopup ? (
        <p
          onClick={() => {
            setOpenModal(true);
          }}
          className={styles.link__text}
        >
          {t("MODEL_INFORMATION")}
        </p>
      ) : (
        <p className={`${styles.link__text} ${styles.text}`}>{t("RRM_MESHUKAL")}</p>
      )}
      {openModal && scoreList.length > 0 && (
        <Modal wide={true} onClose={() => setOpenModal(!openModal)}>
          <RrmModelPopup
            RRMScore={RRMScore}
            score={score}
            scoreList={scoreList}
            popupTitle={popupTitle}
          />
        </Modal>
      )}
    </div>
  );
}

export default RrmLink;
